import { useAuth } from './hooks/useAuth'
import { useDeviceInfo } from './hooks/useDeviceInfo'
import useFetchAccessClientInfo from './hooks/useFetchClientAccessInfo'
import GuestError from './pages/guest-error'
// import Hub from './pages/hub'
import { initializeTrackers } from './utils/tracker'
import { lazy } from 'react'
import { Suspense, useEffect, useState } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

const FeaturedGames = lazy(() => import('./pages/featured'))
const GameByTag = lazy(() => import('./pages/game-by-tag'))
const GameDetail = lazy(() => import('./pages/game-detail'))
const InstantPlay = lazy(() => import('./pages/instant-play'))
const LastPlayedGames = lazy(() => import('./pages/last-played'))
const MostPlayedGames = lazy(() => import('./pages/most-played'))
const NewReleasedGames = lazy(() => import('./pages/new-released'))
const SearchGames = lazy(() => import('./pages/search-game'))
const NotFound = lazy(() => import('./pages/not-found'))

function App() {
  const { isLoading, isGuestAccountError } = useAuth()

  const [isAppReady, setIsAppReady] = useState(false)

  useFetchAccessClientInfo()
  useDeviceInfo()

  useEffect(() => {
    initializeTrackers()
    setIsAppReady(true)
  }, [])

  if (!isAppReady || isLoading) {
    return (
      <div className='flex items-center justify-center h-screen bg-dark-20 text-white'>
        Loading...
      </div>
    )
  }

  return (
    <Suspense
      fallback={
        <div className='flex items-center justify-center h-screen bg-dark-20 text-white'>
          Loading...
        </div>
      }>
      <Routes>
        {isGuestAccountError ? (
          <Route path='*' element={<GuestError />} />
        ) : (
          <>
            <Route path='/' element={<Navigate to='/instant-play' replace />} />
            {/* <Route path='/hub' element={<Hub />} /> */}

            <Route path='/instant-play' element={<InstantPlay />} />
            <Route path='/instant-play/:id' element={<GameDetail />} />
            <Route path='/tags/:tag' element={<GameByTag />} />
            <Route path='/featured' element={<FeaturedGames />} />
            <Route path='/last-played' element={<LastPlayedGames />} />
            <Route path='/new-released' element={<NewReleasedGames />} />
            <Route path='/most-played' element={<MostPlayedGames />} />
            <Route path='/search' element={<SearchGames />} />
            <Route path='/guest-error' element={<GuestError />} />
            <Route path='*' element={<NotFound />} />
          </>
        )}
      </Routes>
    </Suspense>
  )
}

export default App
